import { normalizeToTimestamp } from 'src/utils/dateUtils';

/**
 * Formats a date/timestamp for display (e.g. "Jul 9, 2026").
 * Returns '-' if the input is null/undefined/invalid.
 *
 * Single source of truth for entity date display (audit dates, task due
 * dates, completion dates). Do NOT create per-feature date formatters —
 * use this everywhere a short display date is needed.
 */
export function formatDisplayDate(ts: Date | string | number | null | undefined): string {
  const ms = normalizeToTimestamp(ts);
  if (!ms) return '-';
  return new Date(ms).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
